export var KubeAccessStatus;
(function (KubeAccessStatus) {
    KubeAccessStatus["KUBE_ACCESS_STATUS_INSUFFICIENT_PERMISSIONS"] = "KUBE_ACCESS_STATUS_INSUFFICIENT_PERMISSIONS";
    KubeAccessStatus["KUBE_ACCESS_STATUS_FULL_ACCESS"] = "KUBE_ACCESS_STATUS_FULL_ACCESS";
    KubeAccessStatus["KUBE_ACCESS_STATUS_PARTIAL_ACCESS"] = "KUBE_ACCESS_STATUS_PARTIAL_ACCESS";
    KubeAccessStatus["KUBE_ACCESS_STATUS_NO_NETWORK_ACCESS"] = "KUBE_ACCESS_STATUS_NO_NETWORK_ACCESS";
    KubeAccessStatus["KUBE_ACCESS_STATUS_IAM_ROLE_MISCONFIGURED"] = "KUBE_ACCESS_STATUS_IAM_ROLE_MISCONFIGURED";
    KubeAccessStatus["KUBE_ACCESS_STATUS_CONFIGMAP_ONLY_ACCESS"] = "KUBE_ACCESS_STATUS_CONFIGMAP_ONLY_ACCESS";
    KubeAccessStatus["KUBE_ACCESS_STATUS_ACCESS_DENIED_BY_POLICY"] = "KUBE_ACCESS_STATUS_ACCESS_DENIED_BY_POLICY";
    KubeAccessStatus["KUBE_ACCESS_STATUS_UNSPECIFIED"] = "KUBE_ACCESS_STATUS_UNSPECIFIED";
})(KubeAccessStatus || (KubeAccessStatus = {}));
